<template>
  <v-card flat color="transparent" class="elevation-12">
    <div style="margin: auto 3%">
      <v-btn
        class="rounded-lg white--text elevation-5"
        @click="$store.commit('common/changeEditShortageModalView')"
        color="#05523E"
        style="height: 37px; float: right; margin-top: 10px"
        >Edit List</v-btn
      >
      <div style="padding-bottom: 20px; padding-top: 5.5%">
        <v-data-table
          v-show="isShow"
          :headers="shortageHeaders"
          :items="$store.state.invoice.shortageList"
          :page.sync="Page_No"
          :items-per-page="10"
          hide-default-footer
          class="elevation-3"
          :loading="loading"
        >
          <!-- <template v-slot:header="{ props: { headers } }">
                        <thead>
                            <tr>
                                <th v-for="h in headers" v-bind:key="h.text">
                                    <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                                </th>
                            </tr>
                        </thead>
                    </template> -->
          <!-- class="{'isShortage': Number(item.Required) > 0 }" -->
          <template v-slot:item="{ item }">
            <tr
              v-if="Number(item.Required) > 0"
              style="background-color: rgba(250, 22, 22, 0.21)"
            >
              <td>{{ item.ItemNum }}</td>
              <td>{{ item.ItemName }}</td>
              <td>{{ item.Company }}</td>
              <td>{{ item.dept }}</td>
              <td>{{ item.Required }}</td>
              <td>{{ item.Ordered }}</td>
              <td>{{ item.Available }}</td>
              <td v-if="item.State == 'Checking'">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="true"
                      v-bind="attrs"
                      v-on="on"
                      color="transparent"
                      class="elevation-0"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item-title
                      @click="removeShortage(item.ItemNum)"
                      style="
                        padding: 0px 15px;
                        font-size: 15px;
                        cursor: pointer;
                      "
                      >Delete</v-list-item-title
                    >
                  </v-list>
                </v-menu>
              </td>
              <td v-else></td>
            </tr>
            <tr v-else>
              <td>{{ item.ItemNum }}</td>
              <td>{{ item.ItemName }}</td>
              <td>{{ item.Company }}</td>
              <td>{{ item.dept }}</td>
              <td>{{ item.Required }}</td>
              <td>{{ item.Ordered }}</td>
              <td>{{ item.Available }}</td>
              <td v-if="item.State == 'Checking'">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="true"
                      v-bind="attrs"
                      v-on="on"
                      color="transparent"
                      class="elevation-0"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item-title
                      @click="removeShortage(item.ItemNum)"
                      style="
                        padding: 0px 15px;
                        font-size: 15px;
                        cursor: pointer;
                      "
                      >Delete</v-list-item-title
                    >
                  </v-list>
                </v-menu>
              </td>
              <td v-else></td>
            </tr>
          </template>
        </v-data-table>
        <div v-show="isShow" class="text-center pt-2">
          <v-pagination
            style="padding-top: 8px"
            color="#05523E"
            v-model="Page_No"
            :length="$store.state.invoice.shortagePages"
            :total-visible="10"
            @input="movePage"
          />
        </div>
        <div
          v-show="!$store.state.common.isLoading && !isShow"
          style="font-size: 20px"
        >
          <div
            style="
              margin: 0% 0% 0% 420px;
              font-size: 40px;
              color: #05523e;
              font-weight: bold;
            "
          >
            No data was retrieved.
          </div>
          <img
            style="width: 700px; height: 600px; margin: 0% 0% 0% 250px"
            src="@/assets/noData.jpg"
          />
        </div>
        <div v-if="$store.state.common.editShortageModalView">
          <v-dialog
            class="rounded-lg"
            v-model="$store.state.common.editShortageModalView"
            max-width="70%"
          >
            <EditShortageModal
              @getShortageListLength="getShortageListLength"
              @getShortageList="getShortageList"
            />
          </v-dialog>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import EditShortageModal from "@/components/modal/EditShortageModal.vue";
import { GETSHORTAGELENGTH } from "@/graphql/InvoiceQueries.js";

export default {
  components: {
    EditShortageModal,
  },
  data() {
    return {
      snackbar: false,
      message: "",
      isShow: true,
      tab: null,
      Page_No: 1,
      items: [{ tabName: "Invoice" }, { tabName: "Shortage" }],
      shortageHeaders: [
        {
          text: "Item Number",
          align: "start",
          sortable: true,
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Item Name",
          value: "ItemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Vendor Name",
          value: "Company",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Department",
          value: "dept",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "Required", value: "Required" },
        { text: "Ordered", value: "Ordered" },
        { text: "Available", value: "Available" },
        { text: "", value: "" },
      ],
      loading: false,
    };
  },
  props: {
    source: String,
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("invoice/getCategory");
    await this.getShortageAll();
    this.loading = false;
  },
  methods: {
    async getShortageListLength() {
      try {
        const pageResult = await runGqlQuery(GETSHORTAGELENGTH);
        if (pageResult !== undefined) {
          this.$store.state.invoice.shortagePages = Math.ceil(
            pageResult.getShortagesLength.Length / 10
          );
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getShortageList() {
      try {
        let page_No = 1;
        if (this.Page_No != undefined) page_No = this.Page_No;

        const req = { Page_No: page_No - 1, Page_Size: 10 };

        const result = await this.$store.dispatch(
          "invoice/getShortageList",
          req
        );

        if (result !== "noData") {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getShortageAll() {
      try {
        await this.getShortageListLength();
        await this.getShortageList();
        await this.$store.dispatch("invoice/getShortageListAll");
      } catch (err) {
        console.error(err);
      }
    },
    async removeShortage(itemNum) {
      this.loading = true;
      try {
        await this.$store.dispatch("invoice/deleteShortage", {
          ItemNum: itemNum,
        });
        await this.getShortageAll();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async movePage(page) {
      this.loading = true;
      try {
        this.Page_No = page;
        await this.getShortageList();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
  },
};
</script>
